export const updateEducation=(educationDetails)=>{
 return{type:"UPDATE_EDUCATION" , educationDetails:educationDetails }
}